import { __ }         from '@wordpress/i18n';
import SearchFilter   from './SearchFilter';
import CategoryFilter from './CategoryFilter';
import PriceFilter    from './PriceFilter';
import SortFilter     from './SortFilter';

function perFilterStyle( labelColor, itemColor, accentColor, bgColor, radius, borderWidth, labelSize, itemSize ) {
	const s = {};
	if ( labelColor )        s[ '--mwsb-f-label-color' ]   = labelColor;
	if ( itemColor )         s[ '--mwsb-f-item-color' ]    = itemColor;
	if ( accentColor )       s[ '--mwsb-f-accent' ]        = accentColor;
	if ( bgColor )           s[ '--mwsb-f-bg' ]            = bgColor;
	if ( radius != null )    s[ '--mwsb-f-radius' ]        = radius + 'px';
	if ( borderWidth != null ) s[ '--mwsb-f-border-width' ] = borderWidth + 'px';
	if ( labelSize != null ) s[ '--mwsb-f-label-size' ]    = labelSize + 'px';
	if ( itemSize != null )  s[ '--mwsb-f-item-size' ]     = itemSize + 'px';
	return s;
}

export default function FiltersPanel( { attributes } ) {
	const {
		layout, filterColumns,
		showSearch, orderSearch, spanSearch, searchDebounce,
		showCategories, orderCategories, spanCategories, multiSelect, showProductCount, categoryLayout, categoryRoot = [], categoryRootIncludeChildren, hideEmptyCategories = false, categoryOrderby = 'name_asc',
		showPrice, orderPrice, spanPrice, priceType,
		showSorting, orderSorting, spanSorting,
		showCategoriesLabel = true, showPriceLabel = true, showSortLabel = true,
		searchLabelColor = '', searchItemColor = '', searchAccentColor = '', searchBgColor = '',
		searchRadius, searchBorderWidth,
		catLabelColor = '',    catItemColor = '',    catAccentColor = '',    catBgColor = '',
		catRadius, catBorderWidth, catLabelSize, catItemSize,
		priceLabelColor = '',  priceItemColor = '',  priceAccentColor = '',  priceBgColor = '',
		priceRadius, priceBorderWidth,
		sortLabelColor = '',   sortItemColor = '',   sortAccentColor = '',   sortBgColor = '',
		sortRadius, sortBorderWidth,
	} = attributes;

	const cols = filterColumns || 1;

	const items = [
		{
			key:       'search',
			show:      showSearch,
			order:     orderSearch,
			span:      Math.min( spanSearch, cols ),
			style:     perFilterStyle( searchLabelColor, searchItemColor, searchAccentColor, searchBgColor, searchRadius, searchBorderWidth ),
			component: <SearchFilter debounceMs={ searchDebounce } />,
		},
		{
			key:   'categories',
			show:  showCategories,
			order: orderCategories,
			span:  Math.min( spanCategories, cols ),
			style: perFilterStyle( catLabelColor, catItemColor, catAccentColor, catBgColor, catRadius, catBorderWidth, catLabelSize, catItemSize ),
			component: (
				<>
					{ showCategoriesLabel && <h4 className="mwsb-filter__title">{ __( 'Categories', 'mwsb' ) }</h4> }
					<CategoryFilter
						layout={ categoryLayout }
						multiSelect={ multiSelect }
						showCount={ showProductCount }
						categoryRoot={ categoryRoot }
						categoryRootIncludeChildren={ categoryRootIncludeChildren }
						hideEmptyCategories={ hideEmptyCategories }
						categoryOrderby={ categoryOrderby }
					/>
				</>
			),
		},
		{
			key:       'price',
			show:      showPrice,
			order:     orderPrice,
			span:      Math.min( spanPrice, cols ),
			style:     perFilterStyle( priceLabelColor, priceItemColor, priceAccentColor, priceBgColor, priceRadius, priceBorderWidth ),
			component: <PriceFilter type={ priceType } showLabel={ showPriceLabel } />,
		},
		{
			key:       'sorting',
			show:      showSorting,
			order:     orderSorting,
			span:      Math.min( spanSorting, cols ),
			style:     perFilterStyle( sortLabelColor, sortItemColor, sortAccentColor, sortBgColor, sortRadius, sortBorderWidth ),
			component: <SortFilter showLabel={ showSortLabel } />,
		},
	]
		.filter( ( item ) => item.show )
		.sort( ( a, b ) => a.order - b.order );

	return (
		<div
			className={ `mwsb-filters-panel mwsb-filters-panel--${ layout }` }
			style={ { '--mwsb-filter-cols': cols } }
		>
			{ items.map( ( item ) => (
				<div
					key={ item.key }
					className="mwsb-filter-item"
					style={ { '--mwsb-item-span': item.span, ...item.style } }
				>
					{ item.component }
				</div>
			) ) }
		</div>
	);
}
